import type { FeedbackCue } from './core';
import type { FocusInputModality } from './registry';

export type FeedbackSettings = { uiSounds: boolean; controllerHaptics: boolean };
export type FeedbackRequest = {
  cue: FeedbackCue;
  modality: FocusInputModality;
  route: string;
  settings: FeedbackSettings;
};

export const hapticPatterns: Record<FeedbackCue, { duration: number; weak: number; strong: number }> = {
  'focus-item': { duration: 20, weak: 0.10, strong: 0 },
  'focus-group': { duration: 30, weak: 0.18, strong: 0.03 },
  activate: { duration: 45, weak: 0.20, strong: 0.08 },
  back: { duration: 35, weak: 0.12, strong: 0.02 },
  boundary: { duration: 20, weak: 0.02, strong: 0.08 },
  success: { duration: 50, weak: 0.24, strong: 0.05 },
  error: { duration: 70, weak: 0.12, strong: 0.18 },
};

